import React, { memo } from 'react'

import * as S from '../style'
import SelectBase from 'components/SelectOptions/SelectBase'
import { RequiredBadge } from './RequiredBadge'

type PropsSelect = {
  id: number
  label: string
  value: string
  optionMap: { [key: string]: { value: any; label: any }[] }
  columnName: string
  requiredFlag: boolean
  onChange: (value: string) => void
  isSp?: boolean
  'data-dg-id'?: string
}

const ImportExportSelectRow: React.FC<PropsSelect> = ({
  id,
  optionMap,
  columnName,
  requiredFlag,
  label,
  value,
  onChange,
  isSp,
  'data-dg-id': dataDgId,
}) => {
  const convertToPackageTypeOptions = (): JSX.Element => {
    //@ts-ignore
    const dataOption = optionMap[columnName]

    return (
      <React.Fragment>
        <option value=""></option>
        {(dataOption || []).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </React.Fragment>
    )
  }

  const select = (
    <SelectBase
      data-dg-id={`${isSp ? 'sp-' : ''}entry-load-page-input-${id}`}
      className="w-100 bg-white px-2"
      style={{ height: 40, borderRadius: 4, border: '1px solid #CCC', color: '#000' }}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value)
      }}
    >
      {convertToPackageTypeOptions()}
    </SelectBase>
  )

  // SP: ラベルを上・セレクトを下に縦積み。必須はオレンジバッジ
  if (isSp) {
    return (
      <div className="mb-3" data-dg-id={`sp-${dataDgId}`}>
        <div className="mb-2" data-dg-id={`sp-entry-load-page-label-${id}`}>
          {requiredFlag && <RequiredBadge dataDgId={`sp-entry-load-page-required-${id}`} />}
          {label}
        </div>
        <div data-dg-id={`sp-entry-load-page-input-wrapper-${id}`}>{select}</div>
      </div>
    )
  }

  return (
    <S.SelectInputWrapper data-dg-id={dataDgId}>
      <S.RequiredText data-dg-id={`entry-load-page-required-${id}`}>
        {requiredFlag && '必須'}
      </S.RequiredText>
      <div style={{ width: 145 }} className="label" data-dg-id={`entry-load-page-label-${id}`}>
        {label}
      </div>
      <div style={{ width: 255 }} data-dg-id={`entry-load-page-input-wrapper-${id}`}>
        {select}
      </div>
    </S.SelectInputWrapper>
  )
}

export default memo(ImportExportSelectRow)
